module.exports = __webpack_public_path__ + "static/media/fa-brands-400.8b7a9afd.woff";